import { Typography } from "@mui/material";
import styled from "styled-components";

export const FormButtonsWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-top: ${({ theme }) => theme.spacing(4)};
    border-top: 1px solid ${({ theme }) => theme.colors.lightGrey};
    margin-top: 20px;
`;

export const StyledTypography = styled(Typography)`
    && {
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
    }
`;

export const CameraInfoWrapper = styled.div`
    border: 1px solid ${({ theme }) => theme.colors.lightGrey};
    border-radius: 4px;
    padding: 10px;
    margin-top: 10px;
    margin-bottom: 20px;

    .MuiFormControl-root {
        margin: 0 !important;
        padding: 0;
    }

    .CometAdminFormFieldContainer-horizontal .CometAdminFormFieldContainer-label {
        width: 80px;
    }
`;

export const ContentWrapper = styled.div`
    min-width: 400px;
`;
